import { resolver } from "@msuite/ui/libs/form";
import { useTranslation } from "@msuite/ui/localization";
import { Modal, type ModalProps } from "@msuite/ui/modal";
import {
	type PersonioLinkMemberFormSchema,
	personioLinkMemberFormSchema,
} from "@msuite/utils/schemas";
import { guardString } from "@msuite/utils/strings";
import { FormProvider, useForm } from "react-hook-form";
import { PersonioLinkMemberForm } from "@/forms/personio-link-member-form";
import { useMembers } from "@/hooks/use-members";

/** Props Interface */
interface PersonioLinkMemberModalProps extends ModalProps {
	personName: string;
	excludeUserIds: string[];
	onSelect: (userId: string, userName: string) => void;
}

export function PersonioLinkMemberModal({
	isOpen,
	onClose,
	personName,
	excludeUserIds,
	onSelect,
}: PersonioLinkMemberModalProps) {
	/** Hooks */
	const { t } = useTranslation();
	const methods = useForm<PersonioLinkMemberFormSchema>({
		resolver: resolver(personioLinkMemberFormSchema),
	});

	/** Query */
	const { members } = useMembers();

	/** Functions */
	function handleOnSubmit({ userId }: PersonioLinkMemberFormSchema) {
		let userName = "";
		for (const member of members) {
			if (member.user.id === userId) userName = guardString(member.user.name);
		}
		onSelect(userId, userName);
		onClose();
	}

	/** Render */
	return (
		<FormProvider {...methods}>
			<Modal
				isOpen={isOpen}
				onClose={onClose}
				title={t("integrations.personio_sync.link_member_title", { name: personName })}
				isLoading={methods.formState.isLoading}
				onSubmit={methods.handleSubmit(handleOnSubmit)}
			>
				<Modal.Body>
					<PersonioLinkMemberForm excludeUserIds={excludeUserIds} />
				</Modal.Body>
				<Modal.FooterForm submitLabel={t("integrations.personio_sync.states.link")} />
			</Modal>
		</FormProvider>
	);
}
